import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "question-detail-container"
};
const _hoisted_2 = {
  class: "answers-options-container"
};
const _hoisted_3 = ["type", "name", "value", "checked", "disabled", "onChange"];
const _hoisted_4 = {
  key: 0,
  class: "answer-label"
};
const _hoisted_5 = {
  key: 1,
  class: "answer-image-container"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "answer-image-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_quiz_question_label = _resolveComponent("quiz-question-label");
  const _component_quiz_answers_validation_alert = _resolveComponent("quiz-answers-validation-alert");
  const _component_quiz_question_correction_explanation = _resolveComponent("quiz-question-correction-explanation");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['quiz-checkable-text-question-container', {
      'result-mode': _ctx.isResultMode
    }])
  }, [_ctx.displayOverallVerdictIcon && _ctx.rightAnswersDefined() ? (_openBlock(), _createBlock(_component_icon, {
    key: 0,
    icon: _ctx.overallAnswersVerdictIcon,
    class: _normalizeClass(['question-overall-verdict-icon', _ctx.allAnswersAreCorrect ? 'is-success' : 'is-failure'])
  }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_quiz_question_label, {
    label: _ctx.questionCustomLabel || _ctx.question.label,
    "label-detail": _ctx.question?.information
  }, null, 8, ["label", "label-detail"]), _createElementVNode("div", _hoisted_2, [_ctx.question?.answers?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.question.answers, answer => {
    return _openBlock(), _createElementBlock("label", {
      key: answer.id,
      class: _normalizeClass(['answer-item', {
        'is-selected': _ctx.isSelected(answer.id),
        'is-right-answer': _ctx.isRightAnswer(answer.id),
        'is-bad-answer': _ctx.isBadAnswer(answer.id)
      }])
    }, [_createElementVNode("input", {
      class: _normalizeClass(['answer-input', _ctx.checkType === 'radio' ? 'answer-input-radio' : 'answer-input-checkbox']),
      type: _ctx.checkType,
      name: _ctx.checkType === 'radio' ? `question-${_ctx.question.id}` : `${answer.id}`,
      value: answer.id,
      checked: _ctx.isSelected(answer.id),
      disabled: _ctx.isResultMode,
      onChange: $event => _ctx.onInputChange($event, answer.id)
    }, null, 42, _hoisted_3), _createElementVNode("span", {
      class: _normalizeClass(_ctx.checkType === 'checkbox' ? 'checkbox-cell' : 'radio-cell')
    }, null, 2), answer.label ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(answer.label), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
      src: answer.image?.imagePath,
      class: "answer-image"
    }, null, 8, _hoisted_6), answer.image.imageLabel ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(answer.image.imageLabel), 1)) : _createCommentVNode("", true)])), _ctx.rightAnswersDefined() ? (_openBlock(), _createBlock(_component_icon, {
      key: 2,
      class: _normalizeClass(['answer-verdict-icon', {
        'is-right-answer': _ctx.isRightAnswer(answer.id),
        'is-bad-answer': _ctx.isBadAnswer(answer.id)
      }]),
      icon: _ctx.isRightAnswer(answer.id) ? 'check-circle-outline' : _ctx.isBadAnswer(answer.id) ? 'close-circle-outline' : ''
    }, null, 8, ["class", "icon"])) : _createCommentVNode("", true)], 2);
  }), 128)) : _createCommentVNode("", true)]), _ctx.displayAnswersValidationAlert ? (_openBlock(), _createBlock(_component_quiz_answers_validation_alert, {
    key: 0,
    question: _ctx.question,
    class: "answers-validation-block",
    "answers-validation-state": _ctx.answersValidationState
  }, null, 8, ["question", "answers-validation-state"])) : _createCommentVNode("", true), _ctx.rightAnswersDefined() && _ctx.question.correction ? (_openBlock(), _createBlock(_component_quiz_question_correction_explanation, {
    key: 1,
    class: "correction-explanation-block",
    "question-correction": _ctx.question.correction
  }, null, 8, ["question-correction"])) : _createCommentVNode("", true)])], 2);
}